import React, { createContext, useContext, useState } from "react";

import { surveyQuestions } from "./surveyData";
import { useNavigate } from "react-router-dom";

const INTIAL_DATA = surveyQuestions;

const SurveyContext = createContext();

export const useSurvey = () => {
  return useContext(SurveyContext);
};

export const SurveyProvider = ({ children }) => {
  const [questions, setQuestions] = useState(INTIAL_DATA);
  const [currQuestionIndex, setCurrQuestionIndex] = useState(0);
  const [showSelectOptionMessage, setShowSelectOptionMessage] = useState(false);
  const [showOthersMessage, setShowOthersMessage] = useState(false);

  const navigate = useNavigate();

  //updating checkbox responses basesd on question id
  const updateCheckboxResponse = (id, answer) => {
    setQuestions((prevQuestion) =>
      prevQuestion.map((ques) =>
        ques.id === id
          ? {
              ...ques,
              response: [...answer],
            }
          : ques
      )
    );
  };

  //updating radio responses basesd on question id
  const updateRadioResponse = (id, answer) => {
    setQuestions((prevQuestion) =>
      prevQuestion.map((ques) =>
        ques.id === id
          ? {
              ...ques,
              response: answer,
            }
          : ques
      )
    );
  };

  //updating other responses basesd on question id
  const updateOtherResponse = (id, answer) => {
    setQuestions((prevQuestion) =>
      prevQuestion.map((ques) =>
        ques.id === id
          ? {
              ...ques,
              others: answer,
            }
          : ques
      )
    );
  };

  const nextQuestion = () => {
    // Check if an option is selected
    if (
      questions[currQuestionIndex].response.length === 0 &&
      questions[currQuestionIndex].type === "textbox"
    ) {
      setShowSelectOptionMessage(false);
      setShowOthersMessage(true);
      return;
    }

    // Check if an option is selected
    if (questions[currQuestionIndex].response.length === 0) {
      setShowSelectOptionMessage(true);
      setShowOthersMessage(false);
      return;
    }

    // Check if other option is selected and other field empty
    if (
      questions[currQuestionIndex].response.includes(
        "Other (please specify)"
      ) &&
      questions[currQuestionIndex].others.length === 0
    ) {
      setShowSelectOptionMessage(false);
      setShowOthersMessage(true);
      return;
    }

    setShowOthersMessage(false);
    setShowSelectOptionMessage(false);

    if (questions.length - 1 === currQuestionIndex) {
      //Sending all questions context data to the result page
      navigate("/result", { state: { questions, currQuestionIndex } });
    }
    setCurrQuestionIndex((prev) => prev + 1);
  };

  const prevQuestion = () => {
    setCurrQuestionIndex((prev) => prev - 1);
  };

  return (
    <SurveyContext.Provider
      value={{
        questions,
        currQuestionIndex,
        updateCheckboxResponse,
        updateRadioResponse,
        updateOtherResponse,
        nextQuestion,
        prevQuestion,
        showSelectOptionMessage,
        showOthersMessage,
      }}
    >
      {children}
    </SurveyContext.Provider>
  );
};
